import api from './api';

export interface Project {
  id: number;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count: {
    units: number;
  };
}

export interface CreateProjectData {
  name: string;
}

export interface UpdateProjectData {
  name: string;
}

export const projectService = {
  // Get all projects with optional filter
  getProjects: async (isActive?: boolean): Promise<Project[]> => {
    const params = isActive !== undefined ? { isActive } : {};
    const response = await api.get('/projects', { params });
    return response.data;
  },

  // Get single project by ID
  getProject: async (id: number): Promise<Project> => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  // Create new project
  createProject: async (data: CreateProjectData): Promise<Project> => {
    const response = await api.post('/projects', data);
    return response.data;
  },

  // Update project
  updateProject: async (id: number, data: UpdateProjectData): Promise<Project> => {
    const response = await api.put(`/projects/${id}`, data);
    return response.data;
  },

  // Toggle project active status
  toggleProjectStatus: async (id: number): Promise<Project> => {
    const response = await api.patch(`/projects/${id}/status`);
    return response.data;
  },

  // Delete project
  deleteProject: async (id: number): Promise<void> => {
    await api.delete(`/projects/${id}`);
  },

  // Superadmin-only full cascade purge. Requires the exact project name echoed back.
  purgeProject: async (
    id: number,
    confirmName: string
  ): Promise<{ message: string; deleted: Record<string, number> }> => {
    const res = await api.post(`/projects/${id}/purge`, { confirmName });
    return res.data;
  },
};
